<template>
  <v-container>
    <avs-backButton backTo="Inspections" />

    <AvsTabs
      v-model="tab"
      :loading="loading"
    >
      <template v-slot:tabs>
        <v-tab>
          <v-icon left>mdi-magnify-scan</v-icon>
          {{ $t("commons.informations") }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-alert-outline</v-icon>
          {{ $tc("categories.nonconformity.name", 2) }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-clipboard-text-outline</v-icon>
          {{ $t("categories.inspection.form") }}
        </v-tab>
      </template>

      <template v-slot:items>
        <v-tab-item key="0">
          <avs-editInfoButton :to="{ name: 'InspectionCreateUpdate', params: { id } }" />
          <v-col
            cols="12"
            offset-md="3"
          >
            <InspectionForm
              read-only
              v-model="inspection"
            />
          </v-col>
        </v-tab-item>
        <v-tab-item key="1">
          <NonConformitiesTable :inspectionId="inspection.id">
            <template v-slot:actions>
              <avs-createButton
                :name="
                  $t('actions.new_female', {
                    entity: $tc('categories.nonconformity.name', 1).toLowerCase()
                  })
                "
                :to="{
                  name: 'NonConformityCreateUpdate',
                  query: { inspection: inspection.id }
                }"
                :spantext="
                  $t('actions.create', {
                    entity: $tc('categories.nonconformity.name', 1).toLowerCase()
                  })
                "
              >
              </avs-createButton>
            </template>
          </NonConformitiesTable>
        </v-tab-item>
        <v-tab-item key="2">
          <InspectionDocumentEditor :inspection="inspection" />
        </v-tab-item>
      </template>
    </AvsTabs>
  </v-container>
</template>

<script>
import { InspectionService } from "@/services"
import { mkInspection } from "@/utils/datamodels"

export default {
  name: "Inspection",
  components: {
    AvsTabs: () => import("@/components/generics/general/AvsTabs.vue"),
    InspectionDocumentEditor: () =>
      import("@/components/ri3/documents/InspectionDocumentEditor.vue"),
    InspectionForm: () => import("@/components/ri3/inspection/InspectionForm.vue"),
    NonConformitiesTable: () => import("@/components/ri3/non-conformity/NonConformitiesTable.vue")
  },
  created() {
    this.loading = true
    this.fetchInspection().finally(() => {
      this.loading = false
    })
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  data() {
    return {
      tab: this.$route.params.tab ? this.$route.params.tab : 0,
      inspection: mkInspection(),
      loading: false
    }
  },
  methods: {
    async fetchInspection() {
      return InspectionService.get(this, null, this.id).then(response => {
        this.inspection = response
      })
    }
  }
}
</script>
